// Module
var code = `<div class="js-main{{netTraderState==='WM' ? ' js-main-logged' : ' main-login'}}" {{>NetTraderWindowPart}} on-mousedown="@this.onMouseDown(event)" on-mousemove="@this.onMouseMove(event)" on-mouseup="@this.onMouseUp(event)">
    <!-- header -->
    <div class="js-main-top  {{#if .accW_DnD_Forbidden}}accountWidgetSelector-DnD-Forbidden{{/if}}" {{#.netTraderState==='LM' }} style="display:none;" {{/}}>
        <div class="js-main-top-leftContainer">
            <terceraPictureBox name="leftPicture" useCustomSize="false" imageUrl="{{.leftPictureUrl}}" />
            <div class="js-main-top-leftContainer-btn">
                <terceraButton name="Terminal" terceraButtonStyle="js-button-terminal" text="{{.localkeyTerminal}}" enabled="{{!.accW_DnD_Forbidden}}" on-componentEnter="btnOverTerminal" on-componentClick="ignoreClick" />
                <terceraSeparator isVertical="true" />
                <terceraButton name="Tools" visible="{{.toolsMenuVisible}}" terceraButtonStyle="js-button-terminal" enabled="{{!.accW_DnD_Forbidden}}" text="{{.localkeyTools}}" on-componentEnter="btnOverTools" on-componentClick="ignoreClick" />
                <terceraSeparator isVertical="true" />
                <terceraButton name="More" terceraButtonStyle="js-button-terminal" text="{{.localkeyMore}}" enabled="{{!.accW_DnD_Forbidden}}" on-componentEnter="btnOverMore" on-componentClick="ignoreClick" />
                {{#if externalMenuItems.length}}
                <terceraSeparator isVertical="true" />
                {{/if}}
                {{#each externalMenuItems: num}}
                    <terceraButton terceraButtonStyle="js-button-terminal" text="{{localkeyExternalMenu[num]}}" enabled="{{!.accW_DnD_Forbidden}}" on-componentEnter="['btnOverExternalMenu', num]" on-componentClick="ignoreClick" />
                    {{#if num < externalMenuItems.length - 1}}
                        <terceraSeparator isVertical="true" />
                    {{/if}}
                {{/each}}
            </div>
        </div>
        <div class="js-main-top-centerContainer">
            {{#if (.netTraderState!=='LM' && .netTraderState!=='RM')}}
                <accountWidgetRactive name="accountWidget" properties="{{sessionSettings}}"/>
            {{/if}}
        </div>
        <div class="js-main-top-rightContainer">
            {{#if isNeedPassiveUpdate && !isHideUpdateNotificationButton}}
                <reactButton
                    height="{{clickToUpdateButtonHeight}}"
                    icon="{{clickToUpdateIcon}}"
                    type="{{clickToUpdateType}}"
                    text="{{clickToUpdateBtnText}}"
                    on-onClick="@this.onClickToUpdateButtonClicked()"/>          
            {{/if}}
            <div class="windowConnectionState">
                <div class="connectedStatusPanel">
                    <div class="{{connectedStatus ? 'status-connected' : 'status-reconnected'}}">
                        <svg viewBox="0 0 16 16" fill="none" class="wave-icon">
                            <circle cx="8" cy="7.99994" r="2" fill="currentColor"/>
                            <path d="M14.3423 13.9999C15.3789 12.1673 16 9.88995 16 7.74988C16 5.6629 15.3953 3.66937 14.3962 1.99994H12.2981C13.4573 3.55188 14.0691 5.61023 14.0691 7.74988C14.0691 10.0244 13.2046 12.3839 11.8667 13.9999H14.3423Z" fill="currentColor" class="wave-1"/>
                            <path d="M9 11.9999C9.98047 11.0576 10.8232 9.33978 10.8232 7.81915C10.8232 6.44238 10.3013 4.96204 9.4751 3.99994H11.5859C12.2229 5.10608 12.6206 6.42169 12.6206 7.74988C12.6206 9.13599 12.2041 10.7267 11.5273 11.9999H9Z" fill="currentColor" class="wave-2"/>
                            <path d="M1.65771 13.9999C0.621094 12.1673 0 9.88995 0 7.74988C0 5.6629 0.604736 3.66937 1.60376 1.99994H3.70215C2.54321 3.55188 1.93115 5.61023 1.93115 7.74988C1.93115 10.0244 2.79541 12.3839 4.1333 13.9999H1.65771Z" fill="currentColor" class="wave-1"/>
                            <path d="M4.47266 11.9999H7C6.01953 11.0576 5.17676 9.33978 5.17676 7.81915C5.17676 6.44238 5.69873 4.96204 6.52515 3.99994H4.41406C3.7771 5.10608 3.37939 6.42169 3.37939 7.74988C3.37939 9.13599 3.7959 10.7267 4.47266 11.9999Z" fill="currentColor" class="wave-2"/>
                        </svg>
                    </div>
                    <div class={{.connectedStatus?"connectedStatePanel":"reconnectedStatePanel"}}>{{.connectedStatusText}}</div>
                </div>
                <div class="pingpanel">{{.pingText}}</div>
            </div>
        </div>
    </div>
    <!-- header -->

    <!-- body -->
    <div class="js-main-newNetTrader-innerContainer" on-contextmenu="@this.onContextMenuOpen(event)">
        {{#if .netTraderState==='WM'}}
        {{{.innerHtml}}}
        {{>bodyPartial}}
        {{/if}}
        <sideBar visible="{{.netTraderState==='WM'?true:false}}" 
            isCollapsed="{{.isSideBarCollapsed}}" 
            toggleCollapse="{{@this.toggleSidebarCollapse}}"
            isGeneralSettingsOpened="{{isPropertiesScreenOpened}}"/>
        {{#if .netTraderState==='WM'}}
            <div class="side-bar-backing{{isSideBarCollapsed ? ' collapsed' : ''}}"></div>
        {{/if}}
        <div class="dockMainContainer" id="dockMainContainer"> </div>
        <terceraPanel visible="{{.netTraderState==='WM'?true:false}}" name="topWindowBody" />
        <div id="AttachedPanelsContainer"> </div>
        <div id="HiddenPanelsContainer" style="display:none"> </div>
        {{#if .showUpdateScreen}}
            <updateNotificationScreen on-laterButtonCallback="@this.onLaterUpdateButtonClicked()"/>
        {{/if}}
        {{#if @shared.mainContext.showForceUpdateScreen && netTraderState==='WM'}}
            <forceUpdateNotificationScreen />
        {{/if}}
    </div>
    <!-- body -->

    <!-- footer -->
    <div class="js-main-bottom" {{#if .netTraderState==='LM' || .netTraderState==='AM' }}{{/if}}>
        <terceraTabStrip name="WorkSpacesList" 
            maxElementCount="{{.maxWorkspaceCount}}"
            on-maxElementsCountReached="maxWorkspaceCountReached" 
            isCanChangeWorkspaces="{{connectedStatus}}"/>
        <terceraTicketViewer name="ticketViewer" on-componentClick="click" />
        <div class="js-right">
            <terceraSeparator isVertical="true" />
            <terceraButton name="{{.tradingLocked ? 'tabStripItemLocked' : 'tabStripItemUnlocked'}}" SVG="true" terceraButtonStyle="js-button-locktrading" on-componentClick="lockTradingClick" enabled="true"/>
            <terceraSeparator isVertical="true" />
            <terceraEventLog name="eventlog" enabled="true"/>
            <terceraSeparator isVertical="true" />
        </div>
        <div class="time">
            <terceraTimeZoneSelector name="timeZoneSelector" currentTime="{{.currentTime}} {{.currentTimeZoneOffset}}" />
        </div>
    </div>
    <!-- footer -->

    <terceraLoginScreen 
    visible="{{(.netTraderState==='LM'|| .netTraderState==='RM')?true:false}}" 
    width="312" 
    height="540" 
    name="loginScreen"
    on-setSplashImg="setLoginScreenSplashImg" />
    <terceraPanel name="loginWindowsContainer" />
    <terceraPanel name="quickTableControlContainer"/>
    <terceraPopupBaloon name="popupBaloon" />
    {{#if accountLookupDropDownFormProps != null}}
        <accountLookupDropDownFormRactive accountLookupDropDownFormProps="{{.accountLookupDropDownFormProps}}" on-close="accountLookupDropDownFormClose"/>
    {{/if}}
</div>
<reactContextMenuInstance />
<reactTooltipHover />
<reactTooltipClick />
<reactTooltipError />
{{#partial NetTraderWindowPart}}
{{#.focused}}focused=""{{/}}
style="position:absolute;{{>position}} {{#if .alwaysMiddle}}{{>alwaysMiddlePart}}
{{/if}}{{#if (netTraderState==='LM'|| .netTraderState==='RM') && loginScreenSplashImg != null}}background-image: url('{{loginScreenSplashImg}}');{{/if}}"
showHeader="{{.showHeader?'1':0}}"
showFooter="{{.showFooter?'1':'0'}}"
{{^.resizable}}noResize="1"{{/}}
{{#.showModalmask}}showModalmask{{/}}
{{/partial}}`;
// Exports
export default code;